/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RepositoryDetail {
    getFixupPrototypeFunction() { return RepositoryDetail.fixupPrototype; }

    static newInstance(model: Partial<RepositoryDetail>): RepositoryDetail {
        let obj = Object.assign(new RepositoryDetail(), model);
        RepositoryDetail.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RepositoryDetail>): RepositoryDetail {
        if (!model) return null;
        return RepositoryDetail.newInstance(<RepositoryDetail> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RepositoryDetail) {
        if (!obj) return;

        models.RepositoryDetail.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RepositoryDetail): boolean {
        Object.setPrototypeOf(obj, RepositoryDetail.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Unique Identifier of the Repository.
     */
    repository_id: string;

    /**
     * Unique Name of the Repository.
     */
    repository_name: string;

}
